import React from 'react';

import { IconProps } from './DefaultIcon';

export function ManagementIcon({ className }: IconProps) {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_2_357)">
        <path
          d="M7.21804 80H72.782C76.792 80 80 76.792 80 72.782V7.21804C80 3.20802 76.792 0 72.782 0H7.21804C3.20802 0 0 3.20802 0 7.21804V72.782C0 76.792 3.20802 80 7.21804 80Z"
          fill="#FBFCFE"
        />
        <path
          d="M10.827 72.782H68.9724C70.9774 72.782 72.5814 71.1779 72.5814 69.1729V11.0276C72.5814 9.02256 70.9774 7.41855 68.9724 7.41855H10.827C8.82203 7.41855 7.21802 9.02256 7.21802 11.0276V69.1729C7.21802 71.1779 8.82203 72.782 10.827 72.782Z"
          fill="#EAEEF9"
        />
        <path
          d="M72.7819 69.1729V11.0276L60.3508 21.6541L50.1253 17.8446L37.6942 31.2782L29.2732 27.6692L7.21802 42.3058V69.1729C7.21802 71.1779 8.82203 72.782 10.827 72.782H68.9724C71.1779 72.782 72.7819 71.1779 72.7819 69.1729Z"
          fill="#00C4B3"
        />
        <path
          d="M31.0777 27.6692H28.0702V72.782H31.0777V27.6692Z"
          fill="#FBFCFE"
        />
        <path
          d="M51.7293 17.8446H48.7218V72.7819H51.7293V17.8446Z"
          fill="#FBFCFE"
        />
        <path
          d="M72.782 43.3083L61.9549 37.0927L51.7294 50.5263L40.5013 45.1128L31.0777 57.9449L19.8497 53.1328L7.41858 60.3509V69.1729C7.41858 71.1779 9.02259 72.7819 11.0276 72.7819H69.173C71.178 72.7819 72.782 71.1779 72.782 69.1729V43.3083Z"
          fill="#EAEEF9"
        />
        <path
          d="M50.1253 22.8571C52.8937 22.8571 55.1379 20.613 55.1379 17.8446C55.1379 15.0763 52.8937 12.8321 50.1253 12.8321C47.357 12.8321 45.1128 15.0763 45.1128 17.8446C45.1128 20.613 47.357 22.8571 50.1253 22.8571Z"
          fill="#FBFCFE"
        />
        <path
          d="M29.4737 32.6817C32.2421 32.6817 34.4862 30.4375 34.4862 27.6692C34.4862 24.9008 32.2421 22.6566 29.4737 22.6566C26.7054 22.6566 24.4612 24.9008 24.4612 27.6692C24.4612 30.4375 26.7054 32.6817 29.4737 32.6817Z"
          fill="#FBFCFE"
        />
        <path
          d="M61.9549 42.1053C64.7233 42.1053 66.9674 39.8611 66.9674 37.0927C66.9674 34.3244 64.7233 32.0802 61.9549 32.0802C59.1866 32.0802 56.9424 34.3244 56.9424 37.0927C56.9424 39.8611 59.1866 42.1053 61.9549 42.1053Z"
          fill="#00416B"
        />
        <path
          d="M40.3007 50.1253C43.0691 50.1253 45.3133 47.8811 45.3133 45.1128C45.3133 42.3444 43.0691 40.1003 40.3007 40.1003C37.5324 40.1003 35.2882 42.3444 35.2882 45.1128C35.2882 47.8811 37.5324 50.1253 40.3007 50.1253Z"
          fill="#00416B"
        />
        <path
          d="M19.6491 58.1454C22.4175 58.1454 24.6617 55.9012 24.6617 53.1328C24.6617 50.3645 22.4175 48.1203 19.6491 48.1203C16.8808 48.1203 14.6366 50.3645 14.6366 53.1328C14.6366 55.9012 16.8808 58.1454 19.6491 58.1454Z"
          fill="#00416B"
        />
        <path
          d="M50.1253 20.4511C51.5649 20.4511 52.7318 19.2842 52.7318 17.8446C52.7318 16.4051 51.5649 15.2381 50.1253 15.2381C48.6858 15.2381 47.5188 16.4051 47.5188 17.8446C47.5188 19.2842 48.6858 20.4511 50.1253 20.4511Z"
          fill="#00416B"
        />
        <path
          d="M29.4737 30.2757C30.9132 30.2757 32.0802 29.1087 32.0802 27.6692C32.0802 26.2296 30.9132 25.0627 29.4737 25.0627C28.0342 25.0627 26.8672 26.2296 26.8672 27.6692C26.8672 29.1087 28.0342 30.2757 29.4737 30.2757Z"
          fill="#00416B"
        />
        <path
          d="M63.3583 37.0927H60.3508V72.7819H63.3583V37.0927Z"
          fill="#00416B"
        />
        <path
          d="M61.9549 39.6993C63.3944 39.6993 64.5614 38.5323 64.5614 37.0927C64.5614 35.6532 63.3944 34.4862 61.9549 34.4862C60.5154 34.4862 59.3484 35.6532 59.3484 37.0927C59.3484 38.5323 60.5154 39.6993 61.9549 39.6993Z"
          fill="#00C4B3"
        />
        <path
          d="M21.2531 53.1328H18.2456V72.7819H21.2531V53.1328Z"
          fill="#00416B"
        />
        <path
          d="M41.9047 45.1128H38.8972V72.7819H41.9047V45.1128Z"
          fill="#00416B"
        />
        <path
          d="M40.3007 47.7193C41.7403 47.7193 42.9072 46.5523 42.9072 45.1128C42.9072 43.6732 41.7403 42.5063 40.3007 42.5063C38.8612 42.5063 37.6942 43.6732 37.6942 45.1128C37.6942 46.5523 38.8612 47.7193 40.3007 47.7193Z"
          fill="#00C4B3"
        />
        <path
          d="M19.6491 55.7393C21.0887 55.7393 22.2556 54.5724 22.2556 53.1328C22.2556 51.6933 21.0887 50.5263 19.6491 50.5263C18.2096 50.5263 17.0426 51.6933 17.0426 53.1328C17.0426 54.5724 18.2096 55.7393 19.6491 55.7393Z"
          fill="#00C4B3"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_357">
          <rect width="80" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
